import { HouseIcon, MapPinIcon, PersonIcon, StorefrontIcon } from '@phosphor-icons/react'

import { deliveryMethods } from '@reveni-io/reveni-ui'

export const iconsByType = {
  [deliveryMethods.customerpickup]: HouseIcon,
  [deliveryMethods.pickuppoint]: MapPinIcon,
  [deliveryMethods.customerdelivers]: PersonIcon,
  [deliveryMethods.returntostore]: StorefrontIcon,
}
